import React, { ReactNode, useCallback, useEffect } from 'react';
import { Button, Modal, ModalSubtitle, ModalTitle, ModalTitleContainer } from '@mesa-labs/mesa-ui';
import styled from 'styled-components';
import { signOut } from '../../redux/slices/auth';
import { useDispatch } from '../../redux/hooks';
import { updateShowIdleTimeoutWarningModal } from '../../redux/slices/modals';
import { useLocation } from 'react-router-dom';

const ModalContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  padding: 40px;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

type Props = {
  open: boolean;
};

const Icon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" rx="4" fill="#FFFAEB" />
    <path d="M32.0013 26.668V32.0013M32.0013 37.3346H32.0146M45.3346 32.0013C45.3346 39.3651 39.3651 45.3346 32.0013 45.3346C24.6375 45.3346 18.668 39.3651 18.668 32.0013C18.668 24.6375 24.6375 18.668 32.0013 18.668C39.3651 18.668 45.3346 24.6375 45.3346 32.0013Z" stroke="#DC6803" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function IdleTimeoutWarningModal({ open }: Props): ReactNode {
  const location = useLocation();
  const dispatch = useDispatch();
  const onClose = useCallback(() => dispatch(updateShowIdleTimeoutWarningModal(false)), [dispatch]);

  // auto-close this modal if the user is redireceted to the sign-in page
  useEffect(() => {
    if (open && location.pathname.includes('/sign-in')) {
      onClose();
    }
  }, [open, location.pathname, onClose]);

  return (
    <Modal
      width={500}
      open={open}
      modalRootId="modal-root"
      mobileTop={80}
      onClose={onClose}
      showCloseButton
    >
      <ModalContent>
        <Icon />

        <ModalTitleContainer align="center" gap={24}>
          <ModalTitle>Your session is about to expire</ModalTitle>

          <ModalSubtitle align="center">
            You were inactive for 15 minutes. You will be logged out in 60 seconds.
          </ModalSubtitle>
        </ModalTitleContainer>

        <ButtonContainer>
          <Button
            text="Continue session"
            color="primary"
            onClick={onClose}
          />
          <Button
            text="Log out now"
            color="secondary"
            onClick={() => {
              dispatch(signOut());
              onClose();
            }}
          />
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
}

export default IdleTimeoutWarningModal;
